import { contentModeration } from "../libs/api-url";
import axios from "@/libs/axios";

/**
 * Content Moderation Service
 * One class for the four moderation sections (groups, communities, activities, feedPosts) - they share the same
 * endpoint contract, so every method takes the section key first.
 *
 * API Endpoints (per section, under /api/v1/admin/content-moderation/{section}):
 * - GET    /list        - paginated list (search, status, date_from, date_to, page, limit)
 * - GET    /get         - basic details of one item
 * - PUT    /deactivate  - hide from the app, optional reason
 * - PUT    /reactivate  - make visible again
 * - DELETE /delete      - soft delete (cannot be undone)
 */
class ContentModerationService {
  static async getList(section, params = {}) {
    const response = await axios.get(contentModeration[section].list, {
      params,
    });
    return response.data;
  }

  static async get(section, uuid) {
    const response = await axios.get(contentModeration[section].get, {
      params: { uuid },
    });
    return response.data;
  }

  static async deactivate(section, { uuid, reason }) {
    const response = await axios.put(contentModeration[section].deactivate, {
      uuid,
      ...(reason ? { reason } : {}),
    });
    return response.data;
  }

  static async reactivate(section, uuid) {
    const response = await axios.put(contentModeration[section].reactivate, {
      uuid,
    });
    return response.data;
  }

  static async delete(section, uuid) {
    const response = await axios.delete(contentModeration[section].delete, {
      params: { uuid },
    });
    return response.data;
  }
}

export default ContentModerationService;
